import { createDataModuleActions as createDataModuleActionsUtil } from '@perpay-web/data-module/createDataModuleActions';

const fetchDataModuleActions = createDataModuleActionsUtil(
    'FETCH_FEATURE_ENROLLMENT_FOR_PPP',
);
export const fetchFeatureEnrollmentsForPerpayPlus =
    fetchDataModuleActions.dataRequest;
export const fetchFeatureEnrollmentsForPerpayPlusSuccess =
    fetchDataModuleActions.dataSuccess;
export const fetchFeatureEnrollmentsForPerpayPlusError =
    fetchDataModuleActions.dataError;
export const fetchFeatureEnrollmentsForPerpayPlusReset =
    fetchDataModuleActions.dataReset;
